import request from 'utils/request';
import config from 'config/Config';

export default class {
  // 通知状态
  static notificationStatus() {
    return request({
      url: `mutual/notificationStatus`,
      host: config.HOST_MALL,
      method: 'get',
      data: {}
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Personal/ProfitSharing/ProfitSharingServ.js